import React from "react";
import btnarrow from "../../icons/btnarrow.png";
import docs from "../../icons/docs.png";
import testomonial from "../../images/testmonial.png";

const HomeTestomonials = () => {
  return (
    <div className="container mt-5">
            <div className="label-head   ">-- TESTIMONIAL --</div>

      <div className="row">
        <div className="col-lg-8 ">
          <div>
            <h1 className="">
              What{" "}
              <span className="color-primary">
                Our Client <br />
              </span>
              Say About Us
            </h1>
          </div>
         
        </div>
        <div className="col-lg-4 ">
        <button className="get-started ">
              <img src={btnarrow} alt="" />
              <div className="bg-first color-white">View All Testimonials</div>
            </button>
</div>
        <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
  <div class="carousel-inner">
    <div class="carousel-item active">
    <div className="testomonials-home-card p-5 mb-5 mt-5 row">


            
<div className="col-lg-4 mt-4 mb-4">

  
  <div className="testomonials-home-card-img">
    <div className="testomonials-home-card-img-top">
      <img src={testomonial} alt="" className="first" />
      <img src={docs} alt="" className="second" />
    </div>
  </div>
</div>
<div className="col-lg-8 d-flex flex-column justify-content-center">
  <div class="star-rating">
    <input type="radio" id="5-stars" name="rating" value="5" />
    <label for="5-stars" class="star">
      &#9733;
    </label>
    <input type="radio" id="4-stars" name="rating" value="4" />
    <label for="4-stars" class="star">
      &#9733;
    </label>
    <input type="radio" id="3-stars" name="rating" value="3" />
    <label for="3-stars" class="star">
      &#9733;
    </label>
    <input type="radio" id="2-stars" name="rating" value="2" />
    <label for="2-stars" class="star">
      &#9733;
    </label>
    <input type="radio" id="1-star" name="rating" value="1" />
    <label for="1-star" class="star">
      &#9733;
    </label>
  </div>
  <p>
    "Working with AFS DOTE was an exceptional experience! Their team
    truly understood our vision and transformed our space beyond
    expectations. From concept to completion, they provided expert
    guidance, creativity, and impeccable attention to detail. The
    design perfectly blends functionality with beauty, creating a
    space that feels both luxurious and comfortable. Their
    professionalism, timely delivery, and commitment to quality make
    them stand out. I couldn't be happier with the results and
    highly recommend them to anyone looking for top-tier interior
    design services!"
  </p>
  <p>
    <strong>Sunil Kumar</strong>
  </p>
</div>
</div>
    </div>
    <div class="carousel-item">
    <div className="testomonials-home-card p-5 mb-5 mt-5 row">


            
<div className="col-lg-4 mt-4 mb-4">

  
  <div className="testomonials-home-card-img">
    <div className="testomonials-home-card-img-top">
      <img src={testomonial} alt="" className="first" />
      <img src={docs} alt="" className="second" />
    </div>
  </div>
</div>
<div className="col-lg-8 d-flex flex-column justify-content-center">
  <div class="star-rating">
    <input type="radio" id="5-stars" name="rating" value="5" />
    <label for="5-stars" class="star">
      &#9733;
    </label>
    <input type="radio" id="4-stars" name="rating" value="4" />
    <label for="4-stars" class="star">
      &#9733;
    </label>
    <input type="radio" id="3-stars" name="rating" value="3" />
    <label for="3-stars" class="star">
      &#9733;
    </label>
    <input type="radio" id="2-stars" name="rating" value="2" />
    <label for="2-stars" class="star">
      &#9733;
    </label>
    <input type="radio" id="1-star" name="rating" value="1" />
    <label for="1-star" class="star">
      &#9733;
    </label>
  </div>
  <p>
    "Working with AFS DOTE was an exceptional experience! Their team
    truly understood our vision and transformed our space beyond
    expectations. From concept to completion, they provided expert
    guidance, creativity, and impeccable attention to detail. The
    design perfectly blends functionality with beauty, creating a
    space that feels both luxurious and comfortable. Their
    professionalism, timely delivery, and commitment to quality make
    them stand out. I couldn't be happier with the results and
    highly recommend them to anyone looking for top-tier interior
    design services!"
  </p>
  <p>
    <strong>Sunil Kumar</strong>
  </p>
</div>
</div>
    </div>
    <div class="carousel-item">
    <div className="testomonials-home-card p-5 mb-5 mt-5 row">


            
<div className="col-lg-4 mt-4 mb-4">

  
  <div className="testomonials-home-card-img">
    <div className="testomonials-home-card-img-top">
      <img src={testomonial} alt="" className="first" />
      <img src={docs} alt="" className="second" />
    </div>
  </div>
</div>
<div className="col-lg-8 d-flex flex-column justify-content-center">
  <div class="star-rating">
    <input type="radio" id="5-stars" name="rating" value="5" />
    <label for="5-stars" class="star">
      &#9733;
    </label>
    <input type="radio" id="4-stars" name="rating" value="4" />
    <label for="4-stars" class="star">
      &#9733;
    </label>
    <input type="radio" id="3-stars" name="rating" value="3" />
    <label for="3-stars" class="star">
      &#9733;
    </label>
    <input type="radio" id="2-stars" name="rating" value="2" />
    <label for="2-stars" class="star">
      &#9733;
    </label>
    <input type="radio" id="1-star" name="rating" value="1" />
    <label for="1-star" class="star">
      &#9733;
    </label>
  </div>
  <p>
    "Working with AFS DOTE was an exceptional experience! Their team
    truly understood our vision and transformed our space beyond
    expectations. From concept to completion, they provided expert
    guidance, creativity, and impeccable attention to detail. The
    design perfectly blends functionality with beauty, creating a
    space that feels both luxurious and comfortable. Their
    professionalism, timely delivery, and commitment to quality make
    them stand out. I couldn't be happier with the results and
    highly recommend them to anyone looking for top-tier interior
    design services!"
  </p>
  <p>
    <strong>Sunil Kumar</strong>
  </p>
</div>
</div>
    </div>
  </div>
  <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
</div>
         
      </div>
    </div>
  );
};

export default HomeTestomonials;
